import { render } from "./SelectorTrechosGovPass.vue?vue&type=template&id=80acbd64&scoped=true"
import script from "./SelectorTrechosGovPass.vue?vue&type=script&lang=ts"
export * from "./SelectorTrechosGovPass.vue?vue&type=script&lang=ts"

import "./SelectorTrechosGovPass.vue?vue&type=style&index=0&id=80acbd64&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-80acbd64"

export default script